import moment from "moment/moment"
import MyTooltip from "@common-utils/MyTooltip"
import { Link } from "react-router-dom"
import { ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING } from "../routing/routing-endpoints"
import React from "react"
import { IGetConsultantsDeclarationsVoyantsItemResponseModel } from "./core/_models"

const VoyantsMonthVueSiege = ({ item, mois, contrat }: { item: IGetConsultantsDeclarationsVoyantsItemResponseModel; mois: moment.Moment; contrat: "salarie" | "st" }) => {
     const enAttenteDeReception = item.totalUncreated + item.totalEnCoursDeCreation + item.totalEnCoursDeModification + item.totalEnCoursSignature + item.totalSigneParCollab
     const enCoursRectification = item.totalEnCoursDeRectification + item.totalDemandeRectifParSiege + item.totalSigneParPersonnelApresDemandeRegul
     const aValiderPourLaPaie = item.totalSigneParResponsable
     const valideesPourPaie = item.totalValidePourPaie + item.totalEnAttenteDeValidationDeLaRegularisation

     return (
          <>
               <div className="d-flex justify-content-center mb-2">
                    <MyTooltip title={enAttenteDeReception === 1 ? `Une déclaration en attente de réception` : `${enAttenteDeReception} déclarations en attente de réception`}>
                         <Link
                              to={ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING}
                              state={{ mois: mois.format("YYYY-MM-DD"), etat: "ETAT_ADMIN__EN_ATTENTE_RECEPTION", contrat }}
                              className={`fs-5 btn btn-sm ${enAttenteDeReception > 0 ? "btn-danger" : "btn-outline btn-outline-danger"} btn-icon me-3 ${
                                   enAttenteDeReception === 0 ? "cursor-not-allowed text-muted" : ""
                              }`}
                              onClick={e => enAttenteDeReception === 0 && e.preventDefault()}
                         >
                              {enAttenteDeReception}
                         </Link>
                    </MyTooltip>
                    <MyTooltip title={enCoursRectification === 1 ? `Une déclaration en cours de rectification` : `${enCoursRectification} déclarations en cours de rectification`}>
                         <Link
                              to={ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING}
                              state={{ mois: mois.format("YYYY-MM-DD"), etat: "ETAT_ADMIN__EN_COURS_RECTIFICATION", contrat }}
                              className={`fs-5 btn btn-sm ${enCoursRectification > 0 ? "btn-info" : "btn-outline btn-outline-info"} btn-icon ${
                                   enCoursRectification === 0 ? "cursor-not-allowed text-muted" : ""
                              }`}
                              onClick={e => enCoursRectification === 0 && e.preventDefault()}
                         >
                              {enCoursRectification}
                         </Link>
                    </MyTooltip>
               </div>
               <div className="d-flex justify-content-center">
                    <MyTooltip title={aValiderPourLaPaie === 1 ? `Une déclaration à valider` : `${aValiderPourLaPaie} déclarations à valider`}>
                         <Link
                              to={ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING}
                              state={{ mois: mois.format("YYYY-MM-DD"), etat: "ETAT_ADMIN__A_VALIDER", contrat }}
                              className={`fs-5 btn btn-sm ${aValiderPourLaPaie > 0 ? "btn-warning" : "btn-outline btn-outline-warning"} btn-icon me-3 ${
                                   aValiderPourLaPaie === 0 ? "cursor-not-allowed text-muted" : ""
                              }`}
                              onClick={e => aValiderPourLaPaie === 0 && e.preventDefault()}
                         >
                              {aValiderPourLaPaie}
                         </Link>
                    </MyTooltip>
                    <MyTooltip
                         title={
                              valideesPourPaie === 1
                                   ? contrat === "salarie"
                                        ? `Une déclaration a été validée par le siège`
                                        : `Une déclaration a été facturée`
                                   : contrat === "salarie"
                                   ? `${valideesPourPaie} déclarations ont été validées par le siège`
                                   : `${valideesPourPaie} déclarations ont été facturées`
                         }
                    >
                         <Link
                              to={ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING}
                              state={{ mois: mois.format("YYYY-MM-DD"), etat: "ETAT_ADMIN__VALIDE_POUR_PAIE", contrat }}
                              className={`fs-5 btn btn-sm ${valideesPourPaie > 0 ? "btn-success" : "btn-outline btn-outline-success"} btn-icon ${
                                   valideesPourPaie === 0 ? "cursor-not-allowed text-muted" : ""
                              }`}
                              onClick={e => valideesPourPaie === 0 && e.preventDefault()}
                         >
                              {valideesPourPaie}
                         </Link>
                    </MyTooltip>
               </div>
          </>
     )
}

export default VoyantsMonthVueSiege
